import { action, computed, makeObservable, observable, reaction } from 'mobx'
import { ListItemsObject } from '@voicekey/objects/listItemsObject'

export class ListItemsStore extends ListItemsObject {
  constructor (rootStore) {
    super(rootStore)

    makeObservable(this, {
      resetData: action,
      filters: observable,
      setFilters: action,
      items: observable,
      total: observable,
      page: observable,
      size: observable,
      pagesCount: computed,
      getItems: action,
      setItems: action,
      setPaginationData: action,
      sortFields: observable,
      sortFieldNames: computed,
      setSortFields: action,
      changePage: action,
      changeSize: action
    })

    reaction(
      () => this.rootStore.sessionStore.sessionId,
      () => {
        if (!this.rootStore.sessionStore.sessionId) {
          this.resetData()
        }
      }
    )
  }
}
